<IFA-header>

</IFA-header>

<main id="primary" class="site-main customMain">
  <section class="relative">
    <div class="container px-4 pt-5 mt-120">
      <div class="content-panelMobile">
        <div class='row d-flex'>
          <div class='col-12'>
            <div class='sb-tag sb-offerings mb-12'>
              SEBI
            </div>
            <h2 class='wealth-section-title mb-6'>
              SEBI Categorization of Mutual Fund Schemes
            </h2>
            <p class='wealth-section-description'>
              Know the risks which comes with investments
            </p>
          </div>
        </div>

        <!-- mutual fund Accordian-->

        <div class="lg:w-full lg:max-w-full post-content pb-4 pt-8 lg:pt-6 sm:pt-4">


          <div class="wp-block-columns sec-ques-ans">
            <div class="wp-block-column" style="flex-basis:30%">
              <div class="sidebar-block sticky pt-16">
                <div id="lpwtoc_widget-3" class="widget widget-sidebar widget_lpwtoc_widget">
                  <!--noindex-->
                  <div class="lwptoc lwptoc-autoWidth lwptoc-inherit" data-smooth-scroll="1"
                    data-smooth-scroll-offset="60" data-lwptoc-initialized="1">
                    <div class="lwptoc_i">
                      <div class="lwptoc_header">
                        <b class="lwptoc_title bold UpperCase">SEBI Categorization </b>
                      </div>
                      <div class="lwptoc_items1 lwptoc_items-visible" style="font-size:12pt;">
                        <ol class="lwptoc_itemWrap">
                          <li class="lwptoc_item active">
                            <a href="#Tab1" data-toggle="tab" rel="nofollow">
                              <span class="lwptoc_item_label">Equity Schemes
                              </span>
                            </a>
                          </li>

                          <li class="lwptoc_item"> <a href="#Tab2" rel="nofollow">
                              <span class="lwptoc_item_label">Sector Specific Funds</span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab3" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Thematic funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab4" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Contra Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab5" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Equity Linked Savings Scheme (ELSS)
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab6" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Debt Schemes
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab7" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Short-Term Debt Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab8" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Fixed Maturity Plans (FMPs)
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab9" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Capital Protection Oriented Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab10" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Hybrid Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab11" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Multi Asset Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab12" rel="nofollow">
                              <span class="lwptoc_item_label">
                             Arbitrage Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab13" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Index Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab14" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Exchange Traded Funds (ETFs)
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab15" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Fund of Funds (FoF)
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab16" rel="nofollow">
                              <span class="lwptoc_item_label">
                                Gold Exchange Traded Funds
                              </span>
                            </a>
                          </li>
                          <li class="lwptoc_item"> <a href="#Tab17" rel="nofollow">
                              <span class="lwptoc_item_label">
                                International Funds
                              </span>
                            </a>
                          </li>


                        </ol>
                      </div>
                    </div>
                  </div>
                  <!--/noindex-->
                </div>
              </div>
            </div>

            <div class="wp-block-column mt-120" style="flex-basis:70%">
              <div class="answer-contents calculator_accordian desktop-disabled-acc" id="ques_ans_accordian">
                <div class="what-is-hra ans-card" id="Tab1">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab1_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">

                      SEBI Categorization of Mutual Fund Schemes<i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab1_ans">
                    <div class="main-panel">
                      <div>
                        As per SEBI guidelines on Categorization and Rationalization of schemes issued in October 2017,
                        mutual
                        fund schemes are classified as –

                        Equity Schemes <span class="breakLine"></span>
                        Debt Schemes<span class="breakLine"></span>
                        Hybrid Schemes<span class="breakLine"></span>
                        Solution Oriented Schemes – For Retirement and Children<span class="breakLine"></span>
                        Other Schemes – Index Funds & ETFs and Fund of Funds<span class="breakLine"></span>
                        – Under Equity category, Large, Mid and Small cap stocks have now been defined.<span
                          class="breakLine"></span>

                        – Naming convention of the schemes, especially debt schemes, as per the risk level of underlying
                        portfolio
                        (e.g., the erstwhile ‘Credit Opportunity Fund’ is now called “Credit Risk Fund”)<span
                          class="breakLine"></span>

                        – Balanced / Hybrid funds are further categorised into conservative hybrid fund, balanced hybrid
                        fund
                        and
                        aggressive hybrid fund.<span class="breakLine"></span>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab2">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab2_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Equity Schemes <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab2_ans">
                    <div class="main-panel">
                      <div>
                        <p>An equity Scheme is a fund that – </p>
                        <p><span style="padding-left:40px">– Primarily invests in equities and equity related
                            instruments.</span>
                        </p>
                        <p><span style="padding-left:40px">– Seeks long term growth but could be volatile in the short
                            term.</span>
                        </p>
                        <p><span style="padding-left:40px">– Suitable for investors with higher risk appetite and longer
                            investment
                            horizon.</span></p>
                        <p>The objective of an equity fund is generally to seek long-term capital appreciation. Equity
                          funds may
                          focus on certain sectors of the market or may have a specific investment style, such as
                          investing in
                          value
                          or growth stocks.</p>

                        <p><b>Equity Fund Categories as per SEBI guidelines on Categorization and Rationalization of
                            schemes</b>
                        </p>

                        <table class="table tablelayout" width="100%">
                          <tbody>
                            <tr>
                              <td>Multi Cap Fund*</td>
                              <td>At least 65% investment in equity &amp; equity related instruments</td>
                            </tr>
                            <tr>
                              <td>Large Cap Fund</td>
                              <td>At least 80% investment in large cap stocks</td>
                            </tr>
                            <tr>
                              <td>Large &amp; Mid Cap Fund</td>
                              <td>At least 35% investment in large cap stocks and 35% in mid cap stocks </td>
                            </tr>
                            <tr>
                              <td>Mid Cap Fund</td>
                              <td>At least 65% investment in mid cap stocks</td>
                            </tr>
                            <tr>
                              <td>Small cap Fund</td>
                              <td>At least 65% investment in small cap stocks</td>
                            </tr>
                          </tbody>
                        </table>
                        <span class="breakLine"></span>
                        <table class="table tablelayout" width="100%">
                          <tbody>
                            <tr>
                              <td>Dividend Yield Fund</td>
                              <td>Predominantly invest in dividend yielding stocks, with at least 65% in stocks</td>
                            </tr>
                            <tr>
                              <td>Value Fund</td>
                              <td>Value investment strategy, with at least 65% in stocks</td>
                            </tr>
                            <tr>
                              <td>Contra Fund</td>
                              <td>Scheme follows contrarian investment strategy with at least 65% in stocks</td>
                            </tr>
                            <tr>
                              <td>Focused Fund</td>
                              <td>Focused on the number of stocks (maximum 30) with at least 65% in equity &amp; equity
                                related
                                instruments</td>
                            </tr>
                            <tr>
                              <td>Sectoral/ Thematic Fund</td>
                              <td>At least 80% investment in stocks of a particular sector/ theme</td>
                            </tr>
                            <tr>
                              <td>ELSS</td>
                              <td>At least 80% in stocks in accordance with Equity Linked Saving Scheme, 2005, notified
                                by
                                Ministry
                                of Finance</td>
                            </tr>
                          </tbody>
                        </table>
                        <p>*Also referred to as Diversified Equity Funds – as they invest across stocks of different
                          sectors and
                          segments of the market. Diversification minimizes the risk of high exposure to a few stocks,
                          sectors
                          or
                          segment.</p>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab3">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab3_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Sector Specific
                      Funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab3_ans">
                    <div class="main-panel">
                      <div>
                        <p>Sectoral funds invest in a particular sector of the economy such as infrastructure, banking,
                          technology
                          or pharmaceuticals etc.</p>
                        <p><span style="padding-left:40px">– Since these funds focus on just one sector of the economy,
                            they
                            limit
                            diversification, and are thus riskier.</span></p>
                        <p><span style="padding-left:40px">– Timing of investment into such funds are important, because
                            the
                            performance of the sectors tend to be cyclical.</span></p>

                        <p>Examples of Sector Specific Funds - Equity Mutual Funds with an investment objective to
                          invest in</p>
                        <ul>
                          <li> Pharma &amp; Healthcare Sector</li>
                          <li> Banking &amp; Finance Sector: </li>
                          <li> FMCG (fast moving consumer goods) and related sectors.</li>
                          <li> Technology and related sectors</li>
                        </ul>


                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab4">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab4_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Thematic funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab4_ans">
                    <div class="main-panel">
                      <div>
                        <ul>
                          <li> Thematic funds select stocks of companies in industries that belong to a particular theme
                            - For
                            example, Infrastructure, Service industries, PSUs or MNCs. </li>
                          <li> They are more diversified than Sectoral Funds and hence have lower risk than Sectoral
                            funds.
                          </li>
                        </ul>
                        <h2 class="sub-head-new sub-heading main-block animated fadeInDown">Value Funds (Strategy and
                          Style
                          Based
                          Funds) </h2>
                        <ul>
                          <li> Equity funds may be categorized based on the valuation parameters adopted in stock
                            selection,
                            such as
                            <p><span style="padding-left:40px">– Growth funds identify momentum stocks that are expected
                                to
                                perform
                                better than the market</span></p>
                            <p><span style="padding-left:40px">– Value funds identify stocks that are currently
                                undervalued but
                                are
                                expected to perform well over time as the value is unlocked</span></p>
                          </li>
                          <li> Equity funds may hold a concentrated portfolio to benefit from stock selection.
                            <p><span style="padding-left:40px">– These funds will have a higher risk since the effect of
                                a wrong
                                selection can be substantial on the portfolio’s return</span></p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab5">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab5_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Contra Funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab5_ans">
                    <div class="main-panel">
                      <div>
                        <ul>
                          <li> Contra funds are equity mutual funds that take a contrarian view on the market. </li>
                          <li> Underperforming stocks and sectors are picked at low price points with a view that they
                            will
                            perform
                            in the long run. </li>
                          <li> The portfolios of contra funds have defensive and beaten down stocks that have given
                            negative
                            returns
                            during bear markets. </li>
                          <li> These funds carry the risk of getting calls wrong as catching a trend before the herd is
                            not
                            possible
                            in every market cycle and these funds typically underperform in a bull market. </li>
                          <li> As per the SEBI guidelines on Scheme categorisation of mutual funds, a fund house can
                            either
                            offer a
                            Contra Fund or a Value Fund, not both. </li>
                        </ul>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab6">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab6_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Equity Linked Savings Scheme
                      (ELSS) <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab6_ans">
                    <div class="main-panel">
                      <div>
                        <p>ELSS invests at least 80% in stocks in accordance with Equity Linked Saving Scheme, 2005,
                          notified by
                          Ministry of Finance. </p>
                        <ul>
                          <li> Has lock-in period of 3 years (which is shortest amongst all other tax saving options)
                          </li>
                          <li> Currently eligible for deduction under Sec 80C of the Income Tax Act upto ₹1,50,000 </li>
                        </ul>
                        <h2 class="is-style-fancy-heading" id="DEBT"><span id="DEBT1">DEBT SCHEMES</span></h2>

                        <p>
                        <ul>
                          <li> A debt fund (also known as income fund) is a fund that invests primarily in bonds or
                            other debt
                            securities. </li>
                          <li> Debt funds invest in short and long-term securities issued by government, public
                            financial
                            institutions, companies
                            <p><span style="padding-left:40px">– Treasury bills, Government Securities, Debentures,
                                Commercial
                                paper, Certificates of Deposit and others</span></p>
                          </li>
                          <li> Debt funds can be categorized based on the tenor of the securities held in the portfolio
                            and/or
                            on
                            the basis of the issuers of the securities or their fund management strategies, such as
                            <p><span style="padding-left:40px">– Short-term funds, Medium-term funds, Long-term
                                funds</span></p>
                            <p><span style="padding-left:40px">– Gilt fund, Treasury fund, Corporate bond fund,
                                Infrastructure
                                debt
                                fund</span></p>
                          </li>
                          <li> Floating rate funds, Dynamic Bond funds, Fixed Maturity Plans </li>
                          <li> Debt funds have potential for income generation and capital preservation. </li>
                        </ul>

                        <p><b>Debt Fund Categories as per SEBI guidelines on Categorization and Rationalization of
                            schemes</b>
                        </p>

                        <table class="table tablelayout" width="100%">
                          <tbody>
                            <tr>
                              <td>Overnight Fund</td>
                              <td>Overnight securities having maturity of 1 day</td>
                            </tr>
                            <tr>
                              <td>Liquid Fund</td>
                              <td>Debt and money market securities with maturity of upto 91 days only</td>
                            </tr>
                            <!--<tr><td>Large & Mid Cap Fund</td><td>Debt    and  money market securities with maturity of upto 91 days only</td></tr>-->
                            <tr>
                              <td>Ultra Short Duration Fund</td>
                              <td>Debt &amp; Money Market instruments with Macaulay duration of the portfolio between 3
                                months -
                                6
                                months</td>
                            </tr>
                            <tr>
                              <td>Low Duration Fund</td>
                              <td>Investment in Debt &amp; Money Market instruments with Macaulay duration portfolio
                                between 6
                                months- 12 months</td>
                            </tr>
                            <tr>
                              <td>Money Market Fund</td>
                              <td>Investment in Money Market instruments having maturity upto 1 Year</td>
                            </tr>
                            <tr>
                              <td>Short Duration Fund</td>
                              <td>Investment in Debt &amp; Money Market instruments with Macaulay duration of the
                                portfolio
                                between
                                1 year - 3 years</td>
                            </tr>
                            <tr>
                              <td>Medium Duration Fund</td>
                              <td>Investment in Debt &amp; Money Market instruments with Macaulay duration of portfolio
                                between
                                3
                                years - 4 years</td>
                            </tr>
                            <tr>
                              <td>Medium to Long Duration Fund</td>
                              <td>Investment in Debt &amp; Money Market instruments with Macaulay duration of the
                                portfolio
                                between
                                4 - 7 years</td>
                            </tr>
                            <tr>
                              <td>Long Duration Fund</td>
                              <td>Investment in Debt &amp; Money Market Instruments with Macaulay duration of the
                                portfolio
                                greater
                                than 7 years</td>
                            </tr>
                            <tr>
                              <td>Dynamic Bond</td>
                              <td>Investment across duration</td>
                            </tr>
                            <tr>
                              <td>Corporate Bond Fund</td>
                              <td>Minimum 80% investment in corporate bonds only in AA+ and above rated corporate bonds
                              </td>
                            </tr>
                            <tr>
                              <td>Credit Risk Fund</td>
                              <td>Minimum 65% investment in corporate bonds, only in AA and below rated corporate bonds
                              </td>
                            </tr>
                            <tr>
                              <td>Banking and PSU Fund</td>
                              <td>Minimum 80% in Debt instruments of banks, Public Sector Undertakings, Public Financial
                                Institutions and Municipal Bonds</td>
                            </tr>
                            <tr>
                              <td>Gilt Fund</td>
                              <td>Minimum 80% in G-secs, across maturity</td>
                            </tr>
                            <tr>
                              <td>Gilt Fund with 10 year constant Duration</td>
                              <td>Minimum 80% in G-secs, such that the Macaulay duration of the portfolio is equal to 10
                                years
                              </td>
                            </tr>
                            <tr>
                              <td>Floater Fund</td>
                              <td>Minimum 65% in floating rate instruments (including fixed rate instruments converted
                                to
                                floating
                                rate exposures using swaps/ derivatives) </td>
                            </tr>
                          </tbody>
                        </table>
                        <span class="breakLine"></span>
                        <p>Dynamic Bond funds alter the tenor of the securities in the portfolio in line with
                          expectation on
                          interest rates. The tenor is increased if interest rates are expected to go down and vice
                          versa</p>
                        <span class="breakLine"></span>

                        <p>Floating rate funds invest in bonds whose interest are reset periodically so that the fund
                          earns
                          coupon
                          income that is in line with current rates in the market, and eliminates interest rate risk to
                          a large
                          extent</p>


                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab7">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab7_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Short-Term Debt Funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab7_ans">
                    <div class="main-panel">
                      <div>
                        <p>The primary focus of short-term debt funds is coupon income. Short term debt funds have to also be
                          evaluated for the credit risk they may take to earn higher coupon income. The tenor of the securities
                          will
                          define the return and risk of the fund. </p>
                        <p><span style="padding-left:40px">– Funds holding securities with lower tenors have lower risk and
                            lower
                            return.</span></p>
                        <ul>
                          <li> Liquid funds invest in securities with not more than 91 days to maturity.</li>
                          <li> Ultra Short-Term Debt Funds hold a portfolio with a slightly higher tenor to earn higher coupon
                            income.</li>
                        </ul>
                        <p>Short-Term Fund combine coupon income earned from a pre-dominantly short-term debt portfolio with
                          some
                          exposure to longer term securities to benefit from appreciation in price.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab8">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab8_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Fixed Maturity Plans (FMPs) <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab8_ans">
                    <div class="main-panel">
                      <div>
                        <p>– FMPs are closed-ended funds which eliminate interest rate risk and lock-in a yield by investing
                          only in
                          securities whose maturity matches the maturity of the fund. </p>
                        <p>– FMPs create an investment portfolio whose maturity profile match that of the FMP tenor.</p>
                        <p>– Potential to provide better returns than liquid funds and Ultra Short Term Funds since investments
                          are
                          locked in</p>
                        <p>– Low mark to market risk as investments are liquidated at maturity.</p>
                        <p>– Investors commit money for a fixed period.</p>
                        <p>– Investors cannot prematurely redeem the units from the fund</p>
                        <p>– FMPs, being closed-end schemes are mandatorily listed - investors can buy or sell units of FMPs
                          only on
                          the stock exchange after the NFO.</p>
                        <p>– Only Units held in dematerialized mode can be traded; therefore investors seeking liquidity in such
                          schemes need to have a demat account.</p>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab9">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab9_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Capital Protection Oriented Funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab9_ans">
                    <div class="main-panel">
                      <div>
                        <p>Capital Protection Oriented Funds are close-ended hybrid funds that create a portfolio of debt
                          instruments and equity derivatives </p>
                        <p>– The portfolio is structured to provide capital protection and is rated by a credit rating agency on
                          its
                          ability to do so. The rating is reviewed every quarter.</p>
                        <p>– The debt component of the portfolio has to be invested in instruments with the highest investment
                          grade
                          rating.</p>
                        <p>– A portion of the amount brought in by the investors is invested in debt instruments that is
                          expected to
                          mature to the par value of the capital invested by investors into the fund. The capital is thus
                          protected.
                        </p>
                        <p>– The remaining portion of the funds is used to invest in equity derivatives to generate higher
                          returns
                        </p>


                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab10">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab10_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      HYBRID FUNDS <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab10_ans">
                    <div class="main-panel">
                      <div>
                        <p>Hybrid funds Invest in a mix of equities and debt securities.</p>

                        <p><b>SEBI has classified Hybrid funds into 7 sub-categories as follows:</b></p>
                        <table class="table tablelayout" width="100%">
                          <tbody>
                            <tr>
                              <td>Conservative Hybrid Fund</td>
                              <td>10% to 25% investment in equity &amp; equity related instruments; and <span
                                  class="breakLine"></span> 75% to 90% in Debt
                                instruments</td>
                            </tr>
                            <tr>
                              <td>Balanced Hybrid Fund</td>
                              <td>40% to 60% investment in equity &amp; equity related instruments; and <span
                                  class="breakLine"></span> 40% to 60% in Debt
                                instruments</td>
                            </tr>
                            <tr>
                              <td>Aggressive Hybrid Fund</td>
                              <td>65% to 80% investment in equity &amp; equity related instruments; and <span
                                  class="breakLine"></span> 20% to 35% in Debt
                                instruments</td>
                            </tr>
                            <tr>
                              <td>Dynamic Asset Allocation or Balanced Advantage Fund</td>
                              <td>Investment in equity/ debt that is managed dynamically (0% to 100% in equity &amp; equity
                                related
                                instruments; and <span class="breakLine"></span> 0% to 100% in Debt instruments)</td>
                            </tr>
                            <tr>
                              <td>Multi Asset Allocation Fund</td>
                              <td>Investment in at least 3 asset classes with a minimum allocation of at least 10% in each asset
                                class</td>
                            </tr>
                            <tr>
                              <td>Arbitrage Fund</td>
                              <td>Scheme following arbitrage strategy, with minimum 65% investment in equity &amp; equity
                                related
                                instruments </td>
                            </tr>
                            <tr>
                              <td>Equity Savings</td>
                              <td>Equity and equity related instruments (min.65%); <span class="breakLine"></span>debt
                                instruments (min.10%) and
                                <span class="breakLine"></span>derivatives (min. for hedging to be specified in the SID)
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <span class="breakLine"></span>

                        <p><b>Solution-oriented &amp; Other funds</b></p>
                        <table class="table tablelayout" width="100%">
                          <tbody>
                            <tr>
                              <td>Retirement Fund</td>
                              <td>Lock-in for at least 5 years or till retirement age whichever is earlier</td>
                            </tr>
                            <tr>
                              <td>Children’s Fund</td>
                              <td>Lock-in for at least 5 years or till the child attains age of majority whichever is earlier
                              </td>
                            </tr>
                            <tr>
                              <td>Index Funds/ ETFs</td>
                              <td>Minimum 95% investment in securities of a particular index</td>
                            </tr>
                            <tr>
                              <td>Fund of Funds (Overseas/ Domestic)</td>
                              <td>Minimum 95% investment in the underlying fund(s)</td>
                            </tr>
                          </tbody>
                        </table>

                        <h3><b>Hybrid funds</b></h3>
                        <p> Invest in a mix of equities and debt securities. They seek to find a ‘balance’ between growth and
                          income
                          by investing in both equity and debt.</p>
                        <p style="padding-left:40px">– The regular income earned from the debt instruments provide greater
                          stability
                          to the returns from such funds. </p>
                        <p style="padding-left:40px">– The proportion of equity and debt that will be held in the portfolio is
                          indicated in the Scheme Information Document</p>
                        <p style="padding-left:40px">– Equity oriented hybrid funds (Aggressive Hybrid Funds) are ideal for
                          investors looking for growth in their investment with some stability.</p>
                        <p style="padding-left:40px">– Debt-oriented hybrid funds (Conservative Hybrid Fund) are suitable for
                          conservative investors looking for a boost in returns with a small exposure to equity. </p>
                        <p style="padding-left:40px">– The risk and return of the fund will depend upon the equity exposure
                          taken by
                          the portfolio - Higher the allocation to equity, greater is the risk</p>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab11">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab11_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Multi Asset Funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab11_ans">
                    <div class="main-panel">
                      <div>
                        <ul>
                          <li> A multi-asset fund offers exposure to a broad number of asset classes, often offering a level of
                            diversification typically associated with institutional investing. </li>
                          <li> Multi-asset funds may invest in a number of traditional equity and fixed income strategies,
                            index-tracking funds, financial derivatives as well as commodity like gold. </li>
                          <li> This diversity allows portfolio managers to potentially balance risk with reward and deliver
                            steady,
                            long-term returns for investors, particularly in volatile markets.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab12">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab12_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Arbitrage Funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab12_ans">
                    <div class="main-panel">
                      <div>
                        <p>“Arbitrage” is the simultaneous purchase and sale of an asset to take advantage of the price
                          differential in the two markets and profit from price difference of the asset on different markets or
                          in different forms.</p>
                        <ul class="dashedUl">
                          <li> The securities included in the portfolio and their weights are the same as that in the index
                          </li>
                          <li> The fund manager does not rebalance the portfolio based on their view of the market or sector
                          </li>
                          <li> Index funds are passively managed, which means that the fund manager makes only minor, periodic
                            adjustments to keep the fund in line with its index. Hence, Index fund offers the same return and
                            risk represented by the index it tracks.</li>
                          <li> The fees that an index fund can charge is capped at 1.5%</li>
                        </ul>
                        <p>Investors have the comfort of knowing the stocks that will form part of the portfolio, since the
                          composition of the index is known.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="what-is-hra ans-card" id="Tab13">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab13_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Index Funds <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab13_ans">
                    <div class="main-panel">
                      <div>
                        <p>Index funds create a portfolio that mirrors a market index.</p>
                        <ul class="dashedUl">
                          <li> The securities included in the portfolio and their weights are the same as that in the index
                          </li>
                          <li> The fund manager does not rebalance the portfolio based on their view of the market or sector
                          </li>
                          <li> Index funds are passively managed, which means that the fund manager makes only minor, periodic
                            adjustments to keep the fund in line with its index. Hence, Index fund offers the same return and
                            risk
                            represented by the index it tracks.</li>
                          <li> The fees that an index fund can charge is capped at 1.5%</li>
                        </ul>
                        <p>Investors have the comfort of knowing the stocks that will form part of the portfolio, since the
                          composition of the index is known.</p>
                        <span class="breakLine"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab14">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab14_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Exchange Traded Funds (ETFs) <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab14_ans">
                    <div class="main-panel">
                      <div>
                        <p>An ETF is a marketable security that tracks an index, a commodity, bonds, or a basket of assets like
                          an
                          index fund.
                        </p>
                        <ul>
                          <li> ETFs are listed on stock exchanges. </li>
                          <li> Unlike regular mutual funds, an ETF trades like a common stock on a stock exchange. The traded
                            price
                            of an ETF
                            changes throughout the day like any other stock, as it is bought and sold on the stock exchange.
                          </li>
                          <li> ETF Units are compulsorily held in Demat mode </li>
                          <li> ETFs are passively managed, which means that the fund manager makes only minor, periodic
                            adjustments
                            to keep
                            the fund in line with its index </li>
                          <li> Because an ETF tracks an index without trying to outperform it, it incurs lower administrative
                            costs
                            than
                            actively managed portfolios. </li>
                          <li> Rather than investing in an ‘active’ fund managed by a fund manager, when one buy units of an ETF
                            one
                            is
                            harnessing the power of the market itself. </li>
                          <li> Suitable for investors seeking returns similar to index and liquidity similar to stocks </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab15">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab15_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">
                      Fund of Funds (FoF) <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab15_ans">
                    <div class="main-panel">
                      <div>
                        <ul>
                          <li> Fund of funds are mutual fund schemes that invest in the units of other schemes of the same
                            mutual
                            fund or
                            other mutual funds. </li>
                          <li> The schemes selected for investment will be based on the investment objective of the FoF </li>
                          <li> The FoF have two levels of expenses: that of the scheme whose units the FoF invests in and the
                            expense of the
                            FoF itself. Regulations limit the total expenses that can be charged across both levels as follows:
                            <p style="padding-left:40px">– TER in respect of FoF investing liquid schemes, index funds &amp;
                              ETFs
                              has been
                              capped @ 1% </p>
                            <p style="padding-left:40px">– TER of FoF investing in equity-oriented schemes has been capped @
                              2.25%
                            </p>
                            <p style="padding-left:40px">– TER of FoF investing in other schemes than mentioned above has been
                              capped @2%.
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab16">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab16_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">Gold Exchange Traded Funds
                    <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab16_ans">
                    <div class="main-panel">
                      <div>
                        <ul>
                          <li>
                            Gold ETFs are ETFs with gold as the underlying asset
                            <p style="padding-left:40px">– The scheme will issue units against gold held. Each unit will
                              represent a
                              defined
                              weight in gold, typically one gram.</p>
                            <p style="padding-left:40px">– The scheme will hold gold in form of physical gold or gold related
                              instruments
                              approved by SEBI.</p>
                            <p style="padding-left:40px">– Schemes can invest up to 20% of net assets in Gold Deposit Scheme of
                              banks</p>
                          </li>
                          <li> The price of ETF units moves in line with the price of gold on metal exchange. </li>
                          <li> After the NFO, units are issued to intermediaries called authorized participants against gold or
                            funds
                            submitted. They can also redeem the units for the underlying gold </li>
                        </ul>

                        <h2><b>Benefits of Gold ETFs</b></h2>
                        <ul>
                          <li>
                            Convenience --&gt; option of holding gold electronically instead of physical gold.
                            <p style="padding-left:40px">– Safer option to hold gold since there are no risks of theft or
                              purity.
                            </p>
                            <p style="padding-left:40px">– Provides easy liquidity and ease of transaction.</p>
                          </li>
                          <li>
                            Gold ETFs are treated as non-equity oriented mutual funds for the purpose of taxation.
                            <p style="padding-left:40px">– Eligible for long-term capital gains benefits if held for three
                              years.
                            </p>
                            <p style="padding-left:40px">– No wealth tax is applicable on Gold ETFs </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="what-is-hra ans-card" id="Tab17">
                  <h2 class="is-style-fancy-heading">
                    <a class="acc-title" data-toggle="collapse" data-parent="#ques_ans_accordian" href="#Tab17_ans"
                      aria-expanded="false" aria-controls="what_is_fd_calci_ans">International Funds
                    <i class="arrow-down"></i></a>
                  </h2>
                  <div class="collapse" id="Tab17_ans">
                    <div class="main-panel">
                      <div>
                        <ul>
                          <li>
                            Gold ETFs are ETFs with gold as the underlying asset
                            <p style="padding-left:40px">– The scheme will issue units against gold held. Each unit will
                              represent a
                              defined
                              weight in gold, typically one gram.</p>
                            <p style="padding-left:40px">– The scheme will hold gold in form of physical gold or gold related
                              instruments
                              approved by SEBI.</p>
                            <p style="padding-left:40px">– Schemes can invest up to 20% of net assets in Gold Deposit Scheme of
                              banks</p>
                          </li>
                          <li> The price of ETF units moves in line with the price of gold on metal exchange. </li>
                          <li> After the NFO, units are issued to intermediaries called authorized participants against gold or
                            funds
                            submitted. They can also redeem the units for the underlying gold </li>
                        </ul>

                        <h2><b>Benefits of Gold ETFs</b></h2>
                        <ul>
                          <li>
                            Convenience --&gt; option of holding gold electronically instead of physical gold.
                            <p style="padding-left:40px">– Safer option to hold gold since there are no risks of theft or
                              purity.
                            </p>
                            <p style="padding-left:40px">– Provides easy liquidity and ease of transaction.</p>
                          </li>
                          <li>
                            Gold ETFs are treated as non-equity oriented mutual funds for the purpose of taxation.
                            <p style="padding-left:40px">– Eligible for long-term capital gains benefits if held for three
                              years.
                            </p>
                            <p style="padding-left:40px">– No wealth tax is applicable on Gold ETFs </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>


          </div>
        </div>
        <!-- End-->


      </div>
    </div>

  </section>
  <section class="grid-layout-common">
    <div class="container">
      <div class="col-md-12 col-xs-12 col-sm-12 nopadding">
        <div class="product-card-grid hover-animation" data-grid-size="8">
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card" href="mf/Mutual-Fund" target="_self">

            <span>Mutual Funds - <br><span class="no-wrap-text">Introduction & More</span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card " href="mf/Types_Of_MF" target="_self">

            <span>Various types <br><span class="no-wrap-text">of Mutual Funds</span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card " href="mf/SIP" target="_self">

            <span> Systematic <br><span class="no-wrap-text"> Investment Plan? </span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card  " href="mf/Advantages_Of_MutualFundsComponent"
            target="_self">

            <span>Advantages of <br><span class="no-wrap-text">Mutual Funds</span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card active" href="mf/categorization-of-mutual-funds"
            target="_self">

            <span>Categorisation of <br><span class="no-wrap-text">Mutual Funds </span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card" href="mf/risks-in-mutual-funds" target="_self">

            <span>Risk Factors in <br><span class="no-wrap-text"> Mutual Funds</span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card " href="mf/FAQ#Myth" target="_self">

            <span>Myths & Facts <br><span class="no-wrap-text">about Mutual Funds</span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3" class="card " href="mf/FAQ#FAQ" target="_self">

            <span>What is NAV?<br><span class="no-wrap-text"> & Other FAQs </span></span>
            <span class="icon fa fa-angle-right"></span> </a>
          <a id="id-ebe318f3-49dd-4b4f-9c3a-0cb8514a69fd" class="card link-plain featured customCard"
            (click)="modalPopOpen()" target="_self">
            <p style="font-size:19px;color:#000;font-weight: bold;margin-bottom: 0px;">Schedule a Call back </p>
          </a>
        </div>
      </div>
    </div>
  </section>
  <!-- lets talk of model -->

  <div aria-hidden='true' aria-labelledby='LetsTalk_popup' class='modal fade' data-keyboard='false' id='LetsTalk_popup'
    tabindex='-1'>
    <div class='modal-dialog modal-dialog-centered border-0'>
      <div class='modal-content border-0 p-0'>
        <div class='modal-header border-0 p-0 ltmodalheader'>

          <button aria-label='Close' class='close' data-dismiss='modal' type='button'>
            <span aria-hidden='true'>×</span>
          </button>
        </div>
        <div class='modal-body border-0 p-10 pt-0 mobilep-2'>
          <form>
            <div class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">

              <div class='align-self-center'>
                <h2 class='wealth-section-title mb-8 mobilemb-5 mobilemt-0 fcwelth'>
                  Let's Talk
                </h2>

                <p class='wealth-section-description mb-12 mt-10 mobilemt-0 mobilemb-10'>
                  Let's connect on a quick call to understand better.
                </p>


              </div>


              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12 mt-10 mobilemt-0">
                  <div class="call-plan-form-group call-plan-form-group-name">

                    <input class="form-control" id="customer_name" maxlength="30" placeholder="Full Name"
                      name="customer-name" required="" type="text">
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                    <div class="call-plan-form-group call-plan-form-group-name">

                      <input class="form-control" id="customer_name" placeholder="last name"
                        maxlength="30" name="customer-name" required="" type="text">
                      <label for="customer-name"></label>
                      <span class="d-none customer-name-error" style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div> -->
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">

                    <input class="form-control" id="customer_name" maxlength="30" placeholder="Mobile"
                      name="customer-name" required="" type="text">
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">

                    <input class="form-control" id="customer_name" placeholder="Email" maxlength="30"
                      name="customer-name" required="" type="text">
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">

                   <!-- <select class="form-control">
                      <option>State</option>
                    </select> -->
                    <input class="form-control" id="Statein" placeholder="State" maxlength="30"
                              name="Statein" required="" type="text">
                            <label for="Statein"></label>
                            <span class="d-none Statein-error" style="color: red">
                              Please enter state
                            </span>


                  </div>
                </div>
                <div class="col-sm-6 col-md-6 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">

                    <input class="form-control" id="customer_name" maxlength="30" placeholder="City"
                      name="customer-name" required="" type="text">
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>

              </div>
              <div class="row">

                <div class="col-sm-12 col-md-12 col-xs-6">
                  <div class="call-plan-form-group call-plan-form-group-name">

                    <input class="form-control" id="customer_name" maxlength="30" placeholder="Message"
                      name="customer-name" required="" type="text">
                    <label for="customer-name"></label>
                    <span class="d-none customer-name-error" style="color: red">
                      Please enter your name
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="call-plan-form-group">
                    <label class="form-label">
                      Preferred time to talk:
                    </label>
                  </div>
                  <div class="btn-group btn-group-toggle select-call-time select-call-time-js" data-toggle="buttons">
                    <label class="btn btn-outline-sb-green option-1 active">
                      <input data-max="12" data-min="8" id="option1" name="schedule_time" type="radio" value="morning">

                      10 - 12
                    </label>
                    <label class="btn btn-outline-sb-green option-2">
                      <input data-max="16" data-min="12" id="option2" name="schedule_time" type="radio"
                        value="afternoon">

                      12 - 2
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input data-max="20" data-min="16" id="option3" name="schedule_time" type="radio" value="evening">

                      2 - 4
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input data-max="20" data-min="16" id="option3" name="schedule_time" type="radio" value="evening">

                      4 - 6
                    </label>
                    <label class="btn btn-outline-sb-green option-3">
                      <input data-max="20" data-min="16" id="option3" name="schedule_time" type="radio" value="evening">

                      6 - 8
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">

                <div class="col-md-12 mb-20">
                  <div class="call-plan-form-group  text-center mt-30 mobilemt-0 mobilemb-0">
                    <div class="mt-3 sb-primary-cta-button large-btn  schedule-a-call trigger-event schedule-a-call-js"
                      data-action="schedule a call-Plan" data-category="offering-Plan" data-label="planning section">
                      Call Me
                    </div>
                    <a href="mf/MobileMutualFund" style="font-size:10px;" target="_self" class="anchorColor desktopHide">
                      Click here to know more about
                      Mutual
                      Funds first</a>
                  </div>
                </div>


              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</main>

<IFA-footer>

</IFA-footer>
